// @flow
import React, { Component, Fragment } from 'react';
//types
import { type Currencies } from '../../../../utilities/types';
import { type PartnerDetail } from '../types';
import {
  SmDesktop,
  Tablet,
  Mobile,
  NotLgDesktop
} from '../../../../components/Responsive';
import { Desktop, Default } from '../../../../components/Responsive';
import { ModelListTd } from '../../../../components/ModelListStyles';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import PartnersTableRowExpanded from './PartnersTableRowExpanded';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  data: PartnerDetail,
  currencies: Currencies,
  expandedRow: number,
  expandRow: (id: number) => void,
  tableBodyOptions: {
    selectedIso: string
  }
};

export default class PartnersTableRow extends Component<Props> {
  handleClick = () => {
    this.props.expandRow(this.props.data.id);
  };
  renderExpandedDetailRow = (data: PartnerDetail, colSpan: number) => (
    <NotLgDesktop>
      <PartnersTableRowExpanded
        data={data}
        colSpan={colSpan}
        currencies={this.props.currencies}
      />
    </NotLgDesktop>
  );
  render() {
    const expanded = this.props.expandedRow === this.props.data.id;
    const currency = this.props.currencies[
      this.props.tableBodyOptions.selectedIso
    ];
    return (
      <Fragment key={this.props.data.id}>
        <DefaultModelRowTr
          onClick={this.handleClick}
          expanded={expanded}
          highlighted={expanded}
        >
          <ModelListTd>{this.props.data.company_name}</ModelListTd>
          <Default>
            <ModelListTd right>{this.props.data.merchant_count}</ModelListTd>
          </Default>
          <Default>
            <ModelListTd right>
              {formatCurrency(this.props.data.transaction_amount_sum, currency)}
            </ModelListTd>
          </Default>
          <Desktop>
            <ModelListTd right>
              {formatCurrency(this.props.data.transaction_fee_sum, currency)}
            </ModelListTd>
          </Desktop>
          <ModelListTd right>
            {formatCurrency(this.props.data.revenue_share_sum, currency)}
          </ModelListTd>
        </DefaultModelRowTr>
        {this.props.expandedRow === this.props.data.id && (
          <>
            <SmDesktop>
              {this.renderExpandedDetailRow(this.props.data, 5)}
            </SmDesktop>
            <Tablet>{this.renderExpandedDetailRow(this.props.data, 4)}</Tablet>
            <Mobile>{this.renderExpandedDetailRow(this.props.data, 2)}</Mobile>
          </>
        )}
      </Fragment>
    );
  }
}
